import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { FailureReasonService } from '../../admin/failure-reason/failure-reason.service';
import { FailureReasonBaseData, FailureReasonUsage } from 'common';

@Component({
    selector: 'ifb-transaction-reject-input',
    templateUrl: './transaction-reject-input.component.html',
    standalone: false
})
export class TransactionRejectInputComponent implements OnInit {
  @Input()
  usage: FailureReasonUsage;

  @Input()
  fc: UntypedFormControl;

  @Input()
  disabled: boolean;

  @Input()
  optional: boolean = false;

  constructor(private readonly service: FailureReasonService) {}

  get placeholder(): string {
    switch (this.usage) {
      case FailureReasonUsage.PendingReason:
        return 'Pending reason';

      case FailureReasonUsage.NACHAResponse:
        return 'Decline reason';

      case FailureReasonUsage.ResidualUnderwriting:
        return 'Reject reason';

      default:
        return 'Failure reason';
    }
  }
  failureReasonOptions: FailureReasonBaseData[];

  get required(): boolean {
    return this.optional ? false : this.usage != FailureReasonUsage.PendingReason;
  }

  ngOnInit(): void {
    this.service.list().subscribe((data) => {
      this.failureReasonOptions = [];
      data.forEach((r) => {
        if (r.usage != null && r.usage.includes(this.usage)) this.failureReasonOptions.push(r);
      });
    });
  }
}
